import axiosInstance from '@/utils/httpUtil'
import { setting } from '@/setting'

const adminBaseUrl = setting.adminBaseUrl

export const dropdownOptionsApi = {
    getIndustryTypes: () => {
    return axiosInstance.get(`${adminBaseUrl}/industryTypes`)
    },
    getCompanyTypes: () => {
    return axiosInstance.get(`${adminBaseUrl}/companyTypes`)
    },
    getRecruitmentTypes: () => {
    return axiosInstance.get(`${adminBaseUrl}/recruitmentTypes`)
    },
    getRecruitmentChannels: () => {
    return axiosInstance.get(`${adminBaseUrl}/recruitmentChannels`)
    },
    getRecruitmentAreas: () => {
    return axiosInstance.get(`${adminBaseUrl}/recruitmentAreas`)
    }
}